import * as socket from '@/stores/dataManager/socketServices/socketService';
import { LIST_TAB_PB_ID } from '@/stores/dataStore/memoryStore/const/constIndex';

export const connectSocketAction = () => {
    socket.connect()
}

export const closeSocketAction = () => {
    socket.disconnect()
}


export const subSocketMarketAction = (params: { callerId: string, idPbTab: string, symbols?: string[] }) => {
    // socket.unregisterTopics(topics, callerId)
    try {
        let _exchange = undefined
        let { callerId, idPbTab } = params
        let topics: string[]
        if (!!params.symbols) {
            topics = params.symbols.map(symbol => `${socket.socketRoomName.instrument}:${symbol}`)
            socket.registerTopics(topics, callerId)
        } else {
        switch (idPbTab) {
            case LIST_TAB_PB_ID['HOSE']['id']:
            case LIST_TAB_PB_ID['HNX']['id']:
            case LIST_TAB_PB_ID['UPCOM']['id']:
                _exchange = LIST_TAB_PB_ID[idPbTab]['exchange']
                topics = [`${socket.socketRoomName.exchange}:${_exchange}`]
                socket.registerTopics(topics, callerId)
                break;
            default:
                _exchange = LIST_TAB_PB_ID[idPbTab]['exchange']
                topics = [`${socket.socketRoomName.exchange}:${_exchange}`]
                socket.registerTopics(topics, callerId)
                break;
        }
    }

        return () => { }
    }
    catch (e) {
        return () => { }
    }
}

export const unSubSocketMarketAction = (params: { callerId: string, idPbTab: string, symbols?: string[] }) => {
    // socket.unregisterTopics(topics, callerId)
    try {
        // let _exchange = undefined
        let { callerId, idPbTab } = params
        // let topics: string[]
        switch (idPbTab) {
            case LIST_TAB_PB_ID['HOSE']['id']:
            case LIST_TAB_PB_ID['HNX']['id']:
            case LIST_TAB_PB_ID['UPCOM']['id']:
                // _exchange = LIST_TAB_PB_ID[idPbTab]['exchange']
                // topics = [`${socket.socketRoomName.exchange}:${_exchange}`]
                socket.unregisterCallerId(callerId)
                break;
            default:
                // _exchange = LIST_TAB_PB_ID[idPbTab]['exchange']
                // topics = [`${socket.socketRoomName.exchange}:${_exchange}`]
                socket.unregisterCallerId(callerId)
                break;
        }

        return () => { }
    }
    catch (e) {
        return () => { }
    }
}